import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useTimeZoneNotice } from 'hooks/useTimeZoneNotice';
import { useTranslation } from 'react-i18next';
import { dashboardPageConfigKey } from '../util';

export const useDashboardTimeZoneNotice = (dashboards) => {
  const { t } = useTranslation();
  const { handleShowNotice, showNotice, data, isLoading } = useTimeZoneNotice(
    dashboardPageConfigKey
  );
  useEffect(() => {
    if (showNotice && !isLoading && dashboards.length > 0 && !isEmpty(data)) {
      handleShowNotice(
        t(
          'Your timezone differs from the business timezone. All dashlets are displayed in the business timezone.'
        )
      );
    }
  }, [showNotice, handleShowNotice, isLoading, data, dashboards.length, t]);
};
